// Quantas janelas (Sheet) do app estão abertas agora (0.69, texto 09 C2/D).
// No iPhone, uma janela (Modal) aberta da raiz do app enquanto outra janela já está na tela não aparece:
// o sistema recusa, o React acha que ela está aberta e o controle das telas fica preso. Os avisos grandes que
// moram na raiz (ex.: troca de matéria da Sessão de estudo) esperam as janelas fecharem.
import { useSyncExternalStore } from 'react';

let abertas = 0;
const ouvintes = new Set<() => void>();
const avisar = () => ouvintes.forEach(f => f());

/** Marca uma janela aberta; devolve a função que a marca fechada (chamar uma vez). */
export function abriuJanela() {
  abertas++; avisar();
  let fechou = false;
  return () => { if (fechou) return; fechou = true; abertas = Math.max(0, abertas - 1); avisar(); };
}
export const janelasAbertas = () => abertas;
export const useJanelasAbertas = () => useSyncExternalStore(cb => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; }, () => abertas, () => 0);
